import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const OfficeMembership = lazy(() => import('../pages/office-membership/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/office-membership',
    element: <OfficeMembership />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
